var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.form.status === 3)?_c('div',{attrs:{"id":"main"}},[_c('span',{attrs:{"id":"CheckOrder"}},[_vm._v("订单审核未通过:")]),_c('hr'),_c('el-row',[_c('el-col',[_vm._v(_vm._s(_vm.form.audit_failure_reason))])],1),_c('el-row',[_c('el-col',[_vm._v("我们的客户经理已经与您联系，请您在补充相关信息后，重新提交本订单。")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }